import { redirect } from "react-router-dom";
import { getAuth } from "firebase/auth";

export async function redirectIfNoLogged() {
  const auth = getAuth();
  // auth.updateCurrentUser();

  if (!auth?.currentUser) {
    return redirect("/sign-in");
  }

  return null;
}

export async function redirectIfLogged() {
  const auth = getAuth();

  if (auth?.currentUser) {
    return redirect("/home");
  }

  return null;
}

export async function redirectHome() {
  const auth = getAuth();

  if (!auth?.currentUser) {
    return redirect("/sign-in");
  }

  return redirect("/home");
}
